<div class="login-wrap" [ngClass]="{'otp-wrap-width': ifOtpSent}">
    <div class="head">
        Verify phone number
    </div>
    <div class="popup-contnet">
        <div class="login-box" *ngIf="!ifOtpSent">
            <div class="input-wrap">
                <p>OTP will be shared to <span class="otp-num">{{data.customer_number}}</span> to take further
                    action. Please re-enter the phone number to trigger a verification code.</p>
                <input type="text" placeholder="Enter mobile number" name="mobileNum" [disabled]="ifOtpSent" numberOnly
                    maxlength="10" [(ngModel)]="mobileNumber" (keydown.enter)="sendOTP()" #mobile="ngModel"
                    pattern="^[6-9]\d{9}$" required style="margin-top:1rem;" autocomplete="off">

                <div *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)" class="error-message-wrap">
                    <!-- <div class="mat-error" *ngIf="mobile.errors?.['required']">
                        Mobile number is required.
                    </div> -->
                    <div class="mat-error" *ngIf="mobile.errors?.['pattern']">
                        Please enter a valid mobile number.
                    </div>
                </div>
            </div>

            <div class="captcah-wrap">
              <p>Enter the text as shown in the image </p>
              <input type="text" [(ngModel)]="captchaTxt" [ngClass]="{'captcha-error': showCaptchaError}" maxlength="6">
              <div id="captcha"></div>
              <button (click)="createCaptcha()">
                <mat-icon>autorenew</mat-icon>
              </button>
              @if (showCaptchaError) {
                <div class="mat-error">
                    Invalid captcha.
                </div>
              }
            </div>

            <div class="button-wrap" fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-stroked-button type="button" (click)="closePopup()">Cancel</button>
                <button mat-raised-button color="warn" [disabled]="!mobileNumber || mobileNumber?.length < 10" (click)="sendOTP()">Send OTP</button>
            </div>
        </div>

        <div class="login-box" *ngIf="ifOtpSent" fxLayout="column" fxLayoutAlign="center center">
            <div class="input-wrap">
                <p>OTP sent to <span class="otp-num">{{data.customer_number}}</span> successfully. </p>
            </div>
            <div class="otp-wrap" *ngIf="ifOtpSent">
                <label style="font-weight: 500;font-size: 12px;line-height: 16px;color: #8F949C;">
                    Enter OTP
                </label>
                <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown.enter)="verifyOTP()" [config]="config"
                    style="margin-top:1rem;"></ng-otp-input>
            </div>
            <span
                style="text-decoration:underline;cursor:pointer;font-weight: 600;color: #6AA5DF;font-size: 12px;line-height: 16px;"
                (click)="resendOTP()">Resend OTP?</span>

            <div class="button-wrap" fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-stroked-button type="button" (click)="closePopup()">Cancel</button>
                <button [disabled]="otp.length != 4" mat-raised-button color="warn" (click)="verifyOTP()">Submit OTP</button>
            </div>
        </div>

    </div>




</div>
